import Router from './routes';
import { ConfigProvider } from 'antd';

function App() {
  return (
    <ConfigProvider theme={{
      token: {
        colorPrimary: '#5F77FC',
        sidbarBackground: '#293C68'
      }
    }}>
        <Router />
    </ConfigProvider>

  );
}

export default App;
